import { Paper, TableCell } from '@mui/material';
import { Stack } from '@mui/material';
import { Skeleton } from '@mui/material';
import { TableRow } from '@mui/material';

// Skeleton loading component
const SkeletonTableRows = ({ rowCount = 5 }: { rowCount?: number }) => (
  <>
    <Paper sx={{ height: 'auto', width: '100%' }}>
      {/* Title */}
      <Stack direction="row" alignItems="left" gap="8px" sx={{ margin: '10px' }}>
        <Skeleton variant="text" width={180} height={60} />
        <Skeleton variant="text" width={160} height={60} />
      </Stack>
      {/* Diagnosis Type buttons */}
      <Stack
        direction="row"
        alignItems="center"
        gap="8px"
        sx={{
          maxWidth: '550px',
          borderBottom: 'solid 1px rgba(0, 0, 0, 0.1)',
          margin: '10px',
          paddingBottom: '10px',
        }}>
        <Stack direction="row" alignItems="center" gap="8px">
          <Skeleton variant="circular" width={16} height={16} />
          <Skeleton variant="text" width={150} height={20} />
        </Stack>
        <Stack direction="row" alignItems="center" gap="8px">
          <Skeleton variant="circular" width={16} height={16} />
          <Skeleton variant="text" width={150} height={20} />
        </Stack>
      </Stack>
    </Paper>
    {/* Diagnosis Code Table */}
    <Paper sx={{ height: 'auto', width: '100%' }}>
      {Array.from({ length: rowCount }, (_, index) => (
        <Stack
          direction="row"
          alignItems="center"
          gap="8px"
          key={`skeleton-${index}`}
          sx={{ maxWidth: '750px', borderBottom: 'solid 1px rgba(0, 0, 0, 0.1)', margin: '10px' }}>
          {/* Primary Diagnosis Code Column - 30% width */}
          <Stack direction="row" alignItems="center" gap="8px" sx={{ width: '30%', height: '40px' }}>
            <Skeleton variant="circular" width={16} height={16} />
            <Skeleton variant="text" width={150} height={20} />
          </Stack>

          {/* Description Column - 40% width */}
          <Stack direction="column" justifyContent="center" sx={{ width: '40%', height: '40px' }}>
            <Skeleton variant="text" width="90%" height={20} />
            <Skeleton variant="text" width="70%" height={16} />
          </Stack>

          {/* Status Column - 30% width */}
          <Stack direction="row" alignItems="center" gap="8px" sx={{ width: '30%', height: '40px' }}>
            <Skeleton variant="text" width={150} height={20} />
          </Stack>
        </Stack>
      ))}
    </Paper>
  </>
);

export default SkeletonTableRows;
